<template>
<!-- 售后-常见问题 -->
    <div class="problem">
        <img class="problemPic" src="../assets/icon_changjianwenti@2x.png" alt="常见问题">
        <div class="problemList">
            <router-link :to="{name: 'Maintain'}">
                <span>非现场维护，邮寄时注意事项</span>
                <img src="../assets/icon_fanhui@2x.png" alt="more">
            </router-link>
            <router-link :to="{name: 'NoEquipment'}">
                <span>设备管理中无设备信息</span>
                <img src="../assets/icon_fanhui@2x.png" alt="more">
            </router-link>
        </div>
    </div>
</template>

<script>
export default {
    props: {

    },
    data() {
        return {

        };
    },
    computed: {

    },
    created() {

    },
    mounted() {

    },
    watch: {

    },
    methods: {

    },
    components: {

    },
};
</script>

<style>
html {
    background: #f8f8f8;
}

span {
    color: rgb(51, 51, 51);
    font-size: 40px;
    letter-spacing: 4px;
}

.problem {
    padding: 0 28px;
}

.problem .problemPic {
    width: 164px;
    display: block;
    margin: 62px auto 68px;
}

.problem .problemList {
    background: #ffffff;
    padding: 0 28px;
}

.problem .problemList {
    border-radius: 25px;
    background: #ffffff;
    padding: 0 28px;
}

.problem .problemList a {
    height: 118px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #f0f0f0;
}

.problem .problemList a:last-child {
    border-bottom: none;
}

.problem .problemList img {
    height: 26px;
}
</style>



// WEBPACK FOOTER //
// src/views/CommonProblem.vue